import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {reserveRoutes} from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, TextInput, DateInput } from '../../components/common/components'
import { setFormValue, getAreaCode, submit } from '../../actions'
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
export default function InformationForm() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    let history = useHistory();

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const dispatch = useDispatch()

    const handlechange = useCallback((field, value) => {
        const inputValue = field === "PAT_IDNO"?value.toUpperCase():value

        dispatch(setFormValue({
            field,
            value:inputValue
        }))
        // console.log(field,value);
        if(field === "DOSAGE_COUNT" && value==="1"){
            
            dispatch(setFormValue({
                field:'PRE_VACCINE_TYPE',
                value:""
            }))
        }
    }, [dispatch])

    const handleAddressChange = useCallback((field, value) => {
        const preForm = _.cloneDeep(form)
        dispatch(setFormValue({
            field,
            value
        }))
        if (field === "city" && value !== preForm[field]) {
            dispatch(setFormValue({ field: "AREA_CODE", value: "" }))
            dispatch(getAreaCode())
        }

    }, [dispatch, form])

    const [captchaing, setCaptchaing] = useState(false)

    const [captcha, setCaptcha] = useState(null)

    const [capImg, setCapImg] = useState(null)

    const [captchaInput, setCaptchaInput] = useState("")

    const loadCaptcha = useCallback(
        () => {
          setCaptchaing(true)
          const fetchGetConfig = {
            method: 'GET',
            credentials: 'include'
          }
        //   var myImage = document.querySelector('#captcha202010190819')
          var imageUrl = `https://staff.kfsyscc.org/ca/captcha.jpg`
          
          fetch(imageUrl, fetchGetConfig).then((res) => {
            return res.blob()
          }).then((res) => {
            var objcetURL = URL.createObjectURL(res)
            setCapImg(objcetURL);
    
            fetch(`https://staff.kfsyscc.org/ca/digits`, fetchGetConfig).then((res) => {
    
              return res.json()
            }).then((data) => {
                // console.log(data)
            //   if (!IS_PROD) {
            //     setCaptcha('9999')
            //   }
            //   else {
                setCaptcha(data.digit)
            //   }
              setCaptchaing(false)
            })
          })
        },
        [],
      );
        useEffect(() => {
           loadCaptcha()
            if(!form.conformId){
                let timerFunc = setTimeout(() => {
                    history.push('/')
                }, 700);
                
                return () => clearTimeout(timerFunc);
            }

        }, [])

        

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            <SelectInput
                label="選擇資格"
                field="conformId"
                value={form.conformId}
                // setValue={handlechange}
                options={JSON.stringify(option.conform)}
                disabled
            />
            <SelectInput
                label="預約類別"
                field="reserveType"
                value={form.reserveType}
                // setValue={handlechange}
                options={JSON.stringify(option.reserveType)}
                disabled
            />
            <SelectInput
                label="預約日期"
                field="reserveDate"
                value={form.reserveDate}
                // setValue={handlechange}
                options={JSON.stringify(option.reserveDate)}
                disabled
            />
            <SelectInput
                label="預約時間"
                field="reserveTimeId"
                value={form.reserveTimeId}
                // setValue={handlechange}
                options={JSON.stringify(option.reserveTime)}
                disabled
            />
            <Grid container>
                <Grid item xs={6}>
                    <TextInput
                        label="姓名"
                        field="PAT_NAME"
                        value={form.PAT_NAME}
                        setValue={handlechange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <DateInput
                        label="出生年月日"
                        field="BIRTHDAY"
                        setValue={handlechange}
                        value={form.BIRTHDAY}
                        disabled
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        label="身分證字號"
                        field="PAT_IDNO"
                        value={form.PAT_IDNO}
                        setValue={handlechange}
                        disabled
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        label="性別"
                        field="SEX"
                        value={form.SEX}
                        setValue={handlechange}
                        options={JSON.stringify(option.gender)}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        label="手機號碼"
                        field="TEL_MOBILE"
                        value={form.TEL_MOBILE}
                        setValue={handlechange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        label="e-mail"
                        field="EMAIL"
                        value={form.EMAIL}
                        setValue={handlechange}
                    />
                </Grid>
                {/* <Grid item xs={6}>
                    <TextInput
                        label="工作機構/公司"
                        field="OCC_COMP"
                        value={form.OCC_COMP}
                        setValue={handlechange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        label="職稱"
                        field="OCC_TITLE"
                        value={form.OCC_TITLE}
                        setValue={handlechange}
                    />
                </Grid> */}
                
                
                {/* <Grid item xs={6}>
                    <SelectInput
                        label="居住縣/市"
                        field="city"
                        value={form.city}
                        setValue={handleAddressChange}
                        options={JSON.stringify(option.city)}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        label="居住鄉鎮市區"
                        field="AREA_CODE"
                        value={form.AREA_CODE}
                        setValue={handleAddressChange}
                        options={JSON.stringify(option.AREA_CODE)}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextInput
                        label="居住居住路街/里鄰巷弄/號樓"
                        field="ADDRESS"
                        value={form.ADDRESS}
                        setValue={handlechange}
                    />
                </Grid> */}
                {/* <Grid item xs={6}>                  
                    <SelectInput
                        label="預約施打第幾劑"
                        field="DOSAGE_COUNT"
                        value={form.DOSAGE_COUNT}
                        setValue={handlechange}
                        options={JSON.stringify([{"value":"1", "label":"一"}, {"value":"2", "label":"二"}])}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={6}>
                    {form.DOSAGE_COUNT === "2"?
                    <SelectInput
                        label="第一劑施打品牌"
                        field="PRE_VACCINE_TYPE"
                        value={form.PRE_VACCINE_TYPE}
                        setValue={handlechange}
                        options={JSON.stringify(option.vaccine)}
                        variant="standard"
                    />:null}
                </Grid> */}
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6}>
                    <TextInput
                        label="驗證碼"
                        field="captchaInput"
                        value={captchaInput}
                        setValue={(field, value)=>{setCaptchaInput(value)}}
                    />
                </Grid>
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6} style={{padding:"5px"}}>
                    {capImg?<img alt="captcha" src={capImg} style={{ height:"80%", objectFit:"contain"}}/>:null}                    
                </Grid>
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6} style={{display:"flex", alignItems:"center"}}>
                    <Button color="primary" variant="contained" onClick={()=>loadCaptcha()}>取得新驗證碼</Button>
                </Grid>
            </Grid>
            {form.loading?
            <div style={{
                position:"absolute", 
                left:0, 
                right:0, 
                top:0, 
                bottom:0, 
                backgroundColor:"rgba(0,0,0,0.3)",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
            }}>
                <CircularProgress size={200}/>
            </div>:null}

        </Paper>
        {!form.loading?<>
            <Button
            variant="contained"            
            style={{ margin: "30px" }}
            onClick={() => { history.goBack() }}
        >
            上一步
        </Button>
        <Button
            variant="contained"
            color="primary"
            style={{ margin: "30px" }}
            onClick={() => { 
                if(captcha === "" || captcha !== captchaInput){
                    Swal.fire("驗證碼不符", "", "error")
                    return
                } 
                dispatch(submit()) 
            }}
        >
            送出
        </Button>
        
        </>:null}
       
    </Box>
}
